import { SHOW_LOADER, HIDE_LOADER } from '../loader/actionTypes';

const initState = {
  loader: {
    show: false,
  }
};
/**
 * Reducer function for managing the state of the loader.
 * @param {Object} state - The current state of the loader.
 * @param {Object} action - The action object that contains the type of action to perform.
 * @returns The updated state of the loader.
 */
const LoaderReducer = (state = initState, action) => {
  if (action.type === SHOW_LOADER) {
    return {
      ...state,
      loader: { show: true }

    };
  }
  if (action.type === HIDE_LOADER) {
    return {
      ...state,
      loader: { show: false }
    };
  }

  return state;
};

export default LoaderReducer;
